import script from "./UserItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserItem.vue?vue&type=script&lang=ts&setup=true"

import "./UserItem.vue?vue&type=style&index=0&id=769c3bb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769c3bb2"]])

export default __exports__